<template>
  <div id="seal">
    <el-card class="index" >
      <div class="menu">
        <el-menu :default-active="$route.name" :key="key" class="el-menu-demo" mode="horizontal" @select="SelectMenu"
          >
          <el-menu-item v-for="(item, index) in targetRoutes" :key="index" :index="item.path">
            {{ item.meta.title }}
          </el-menu-item>
        </el-menu>
      </div>
      <el-button
          class="btn"
            type="success"
            @click="enter()"
            v-if="
              this.$store.state.rolesname.includes('bankruptcyManagerInput')
            "
          >
            录入
          </el-button>
          <!-- 折腾跳转是出现的文字 -->
          <div class="kb"></div>
          <div class="xian"></div>
          <router-view ref="childView"></router-view>

    </el-card>
 

    <el-dialog
      title="详情"
      :visible.sync="detailsDialog"
      width="80%"
      style="text-align: center"
       :close-on-click-modal="false"
      @closed="handleClose"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="formref"
        label-width="170px"
        class="demo-form"
      >
        <el-form-item label="破产企业名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
         <el-form-item label="身份证号/社会信用代码/护照号" prop="idnumber">
          <el-input v-model="form.idnumber"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="代理律师(主)" prop="leadLawyer">
              <el-select
                style="width: 100%"
                v-model="form.leadLawyer"
                placeholder="请选择"
                class="select"
                clearable
                filterable
                @change="LeadLawyerChange(form.leadLawyer)"
              >
                <el-option
                  v-for="item in Lawyer"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="代理律师(副)" prop="coCounsel">
              <el-select
                style="width: 100%"
                v-model="form.coCounsel"
                placeholder="请选择"
                class="select"
                clearable
                multiple
                filterable
              >
                <el-option
                  v-for="item in Lawyer"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="破产项目来源" prop="soure">
              <el-select
                style="width: 100%"
                v-model="form.soure"
                placeholder="请选择"
                class="select"
                clearable
                filterable
              >
                <el-option
                  v-for="item in SoureOptions"
                  :key="item.nikename"
                  :label="item.label"
                  :value="item.nikename"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收案日期" prop="approvaldate">
              <div
                class="date_box"
                @mouseover="onMouseOver()"
                @mouseleave="onMouseleave()"
              >
                <el-date-picker
                  style="width: 100%"
                  v-model="form.approvaldate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="请选择"
                  clearable
                >
                </el-date-picker>
                <i class="el-icon-date" ref="iconDate"></i>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="部门审批人"
              prop="caseLeaders"
              key="caseLeaders"
            >
              <el-select
                style="width: 100%"
                v-model="form.caseLeaders"
                placeholder="请选择"
                class="select"
                filterable
                clearable
              >
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="二次审批人" prop="level">
              <el-select
                style="width: 100%"
                v-model="form.level"
                placeholder="请选择"
                class="select"
                clearable
                filterable
              >
                <el-option
                  v-for="item in Level"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="用章类型" prop="sealtype">
          <el-select
            style="width: 100%"
            v-model="form.sealtype"
            placeholder="请选择"
            class="select"
            clearable
            filterable
          >
            <el-option
              v-for="item in Seal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <div style="text-align: center">
            <el-button type="primary" @click="inputCase('formref')" :disabled="isAdd"
              >确认提交</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 案件冲突 -->
    <el-dialog
      title="冲突"
      :visible.sync="caseConflict"
      width="80%"
      style="text-align: center"
      @close="CancelEntry"
    >
      <el-form  ref="formConflict" :model="formConflict" label-width="150px" :rules="rulesConflict">
        <el-row v-if="conflictShow" >
        <el-col :span="8">
          <el-form-item label="二次利冲审批人" prop="conflictApproval" >
              <el-select
                v-model="formConflict.conflictApproval"
                clearable
                placeholder="请选择二次利冲审批人"
                filterable
                style=" width: 100%;"
              >
                <el-option
                  v-for="item in OptiomConflict"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div v-if="OptiomConflict.length<1&&allConflictCount>0" style="color:red;font-size:18px; margin-bottom:12px;">暂无二次利冲审批人，无法录入</div>
     
      <br />
      <h2>
        案件冲突<span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方,灰色背景是导入数据)</span
        >
      </h2>
      <el-table
        :data="conflictList"
        style="width: 100% ; height:200"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :row-class-name="tableRowClass"
        max-height="380px"
      >
        <el-table-column prop="code" label="案件编号" width="100">
        </el-table-column>
        <el-table-column prop="title" label="案件名称" width="240">
        </el-table-column>
        <el-table-column prop="litigant" label="当事人" min-width="300">
          <template slot-scope="scope">
            <div v-for="(c,index) in scope.row.litigant " class="litigant-container">
                {{ c.attribute }}：
                <span
                  v-for="(item, index) in c.all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < c.all.length - 1"
                    >,
                  </span>
                </span>
              </div>
           
          </template>
        </el-table-column>
        <el-table-column label="冲突对象"> 
            <template slot-scope="scope">
              {{ GetNameIdnumber(scope.row.litigant)}}
            </template>
            </el-table-column>
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <el-button @click="conflictClick(scope.row)" v-if="!scope.row.isOther"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      
      <div v-if="dialoghasMore" style="text-align: center;">
          <el-button  type="text" @click="dialogshowAllCaseClick" >
            {{ dialogshowAllCase ? '收起' : `查看更多` }}
          </el-button>
        </div>

      <div class="conflic_btn">
        <el-button @click="conflict('formConflict')" type="primary" :disabled="dianji" v-if="!(allConflictCount>0&&OptiomConflict.length<=0)"
          >继续录入</el-button
        >
        <el-button type="warning" @click="CancelEntry()">取消录入</el-button>
      </div>
    </el-dialog>

     <!-- 冲突预览 -->
     <el-dialog
      center
      title="预览"
      :visible.sync="isChong"
      append-to-body
      class="file-dialog"
      width="85%"
      @close="closChong"
    >
      <el-form class="form" ref="formrefCT" :model="CTform" label-width="200px">
        <!-- 案件当事人 -->
        <div
          v-if="
            chongCaseType == 1 ||
            chongCaseType == 2 ||
            chongCaseType == 3 ||
            chongCaseType == 4 ||
            chongCaseType == 5 ||
            chongCaseType == 6||chongCaseType == 9
          "
          style="width: 90%"
        >
          <div class="divider"></div>
          <div class="top">
            <div class="icon"></div>
            <div>案件当事人</div>
          </div>
          <el-row>
            <el-table
              class="party"
              border
              :data="CTform.tableData"
               style="width: calc(100% - 61px);"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                label="属性"
                prop="attribute"
                :render-header="addRedStar"
                width="160"
              >
                <template slot-scope="scope">
                  <el-select
                    size="mini"
                    v-model="scope.row.attribute"
                    clearable
                    filterable
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in ArrtibuteOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="类型"
                prop="isUnit"
                :render-header="addRedStar"
                width="100"
                v-if="chongCaseType != 9"
              >
                <template slot-scope="scope">
                  <el-select
                    size="mini"
                    v-model="scope.row.isUnit"
                    clearable
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="姓名/单位名称"
                prop="name"
                :render-header="addRedStar"
                :show-overflow-tooltip="true"
                min-width="360"
              >
              </el-table-column>
              <el-table-column
                label="身份证号/社会信用代码/护照号"
                prop="idnumber"
                :render-header="addRedStar"
                :show-overflow-tooltip="true"
                min-width="360"
              >
              </el-table-column>
              <el-table-column
                label="委托方"
                prop="isClient"
                :render-header="addRedStar"
                width="80"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    :disabled="bianji"
                    v-model="scope.row.isClient"
                    @change="clientChange(scope.row)"
                  ></el-checkbox>
                </template>
              </el-table-column>

            
            </el-table>
          </el-row>
        </div>

        <div class="text">
          <div style="width: 90%">案件信息：{{ CTform.title }}</div>
        </div>
        <div
          v-if="
            chongCaseType == 1 ||
            chongCaseType == 2 ||
            chongCaseType == 3 ||
            chongCaseType == 4 ||
            chongCaseType == 5 ||
            chongCaseType == 6
          "
          style="width: 90%"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="案件名称" prop="title">
                <el-input
                  v-model="CTform.title"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" v-if="chongCaseType == 3">
              <el-form-item label="公益诉讼" prop="public_welfare">
                <el-select
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.public_welfare"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="受理机构案号" prop="acceptcode">
                <el-input
                  v-model="CTform.acceptcode"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件编号" prop="code">
                <el-input
                  v-model="CTform.code"
                  placeholder="自动编号"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" v-if="chongCaseType != 4">
              <el-form-item label="法律援助" prop="assist">
                <el-select
                  v-model="CTform.assist"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in Flyz"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案卷状态" prop="ajstatus">
                <el-select
                  v-model="CTform.ajstatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                  @change="inputType(form.ajstatus, null)"
                >
                  <el-option
                    v-for="item in Ajstatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    style="width: 100%"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="10">
              <el-form-item label="受理状态" prop="casestatus">
                <el-select
                  disabled
                  v-model="CTform.casestatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CaseStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                size="small"
                @click="Accept()"
                style="margin-left: 10px; margin-top: 4px"
                v-if="CTform.casestatus == '未受理' && bianji && form.uid"
                type="primary"
                plain
                >点此受理</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" class="date_box">
              <el-form-item label="收案日期" prop="approvaldate">
                <div
                  class="date_box"
                  @mouseover="onMouseOver()"
                  @mouseleave="onMouseleave()"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="CTform.approvaldate"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="系统自动生成"
                    clearable
                    disabled
                  >
                  </el-date-picker>
                  <!-- <i class="el-icon-date" ref="iconDate"></i> -->
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件来源" prop="source">
                <el-input
                  v-model="CTform.source"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="受理机构" prop="acceptUnit">
                <el-input
                  v-model="CTform.acceptUnit"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案由" prop="cause">
                <el-input
                  v-model="CTform.cause"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="代理律师" prop="leadLawyer">
                <el-select
                  style="width: 100%"
                  v-model="CTform.leadLawyer"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  :multiple-limit="1"
                  @change="LeadLawyerChange(CTform.leadLawyer)"
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="false">
              <el-form-item
                label="委托事项"
                prop="remark"
                v-if="chongCaseType != 2"
              >
                <el-select
                  style="width: 100%"
                  v-model="CTform.remark"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in Entrust"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="chongCaseType == 2"
                label="介入阶段"
                prop="intervene"
              >
                <el-select
                  filterable
                  v-if="CTform.bcz != null"
                  style="width: 100%"
                  v-model="CTform.bcz.intervene"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in Intervene"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="chongCaseType == 2">
            <el-col :span="12" v-if="CTform.result == 1">
              <el-form-item label="刑事风险控制人" prop="criminalrisk">
                <el-select
                  style="width: 100%"
                  v-model="CTform.criminalrisk"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Criminal"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="12"
              v-if="
                chongCaseType != 7 &&
                chongCaseType != 8 &&
                chongCaseType != 14 &&
                chongCaseType != 9 &&
                CTform.result == 1
              "
            >
              <el-form-item label="二次审批人" prop="level">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.level"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  multiple
                  :multiple-limit="1"
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Level"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="代理律师" prop="coCounsel">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.coCounsel"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="CTform.result == 1">
            <el-form-item label="部门主管" prop="caseLeaderscase">
              <el-select
                filterable
                placeholder="请选择"
                clearable
                v-model="CTform.caseLeaderscase"
                @change="bmzgChange"
              >
              
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </div>

        <div v-else style="width: 90%">
          <el-row>
            <el-col :span="24">
              <el-form-item label="项目名称" prop="title">
                <el-input v-model="CTform.title" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="受理机构案号" prop="acceptcode">
              <el-input
                v-model="CTform.acceptcode"
                placeholder="请输入"
                clearable
                :disabled="bianji"
              ></el-input>
            </el-form-item>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="项目概要" prop="cause">
                <el-input
                  v-model="CTform.cause"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="案件编号" prop="code">
                <el-input
                  v-model="CTform.code"
                  placeholder="自动编号"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="案卷状态" prop="ajstatus" v-if="chongCaseType != 12 && chongCaseType !=13">
                <el-select
                  v-model="CTform.ajstatus"
                  placeholder="请选择"
                  class="input"
                  style="width: 100%"
                  disabled
                  @change="inputType(form.ajstatus, null)"
                >
                  <el-option
                    v-for="item in Ajstatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="破产案件类型" prop="bcz.projecttype" v-if="chongCaseType == 12">
                    <el-select
                      style="width: 100%"
                      v-model="CTform.bcz.projecttype"
                      placeholder="请选择"
                      class="select"
                      disabled
                    >
                      <el-option
                        v-for="item in ProjectType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="12">
              <el-form-item label="受理状态" prop="casestatus">
                <el-select
                  disabled
                  v-model="CTform.casestatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CaseStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                size="small"
                @click="Accept()"
                style="margin-left: 20px"
                v-if="CTform.casestatus == '未受理' && bianji && CTform.uid"
                type="primary"
                plain
                >点此受理</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="项目合伙人" prop="partner">
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.partner"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="底稿资料" prop="draft">
                <el-select
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.draft"
                  placeholder="请选择"
                  class="select"
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in Draft"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 一般非诉项目、单独出具律师意见审批书、单独出具律师函没有二次审批人 -->
          <el-row
            v-if="
              chongCaseType != 7 &&
              chongCaseType != 8 &&
              chongCaseType != 14 &&
              chongCaseType != 9 &&
              (form.result == 1 || bianji == false)
            "
            style="width: 90%"
          >
            <el-col :span="14">
              <el-form-item label="二次审批人" prop="level">
                <el-select
                  style="width: 100%"
                  v-model="CTform.level"
                  class="select"
                  multiple
                  :multiple-limit="1"
                  disabled
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Level"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="divider"></div>
          <el-row>
            <el-col :span="14" class="date_box">
              <el-form-item label="立项日期" prop="approvaldate">
                <el-date-picker
                  style="width: 100%"
                  v-model="CTform.approvaldate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="系统自动生成"
                  disabled
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="项目来源" prop="source">
                <el-input
                  v-model="CTform.source"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item
                :label="chongCaseType == 10 ? '代理机构' : '受理机构'"
                prop="acceptUnit"
                v-if="chongCaseType == 10"
              >
                <el-input v-model="CTform.acceptUnit" disabled></el-input>
              </el-form-item>
              <el-form-item
                :label="chongCaseType == 12 ? '管辖法院' : '受理机构'"
                v-if="chongCaseType != 10"
              >
                <el-input v-model="CTform.acceptUnit" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :span="10"
              v-if="
                chongCaseType == 7 ||
                chongCaseType == 8 ||
                chongCaseType == 14 ||
                chongCaseType == 9 ||
                chongCaseType == 11
              "
            >
              <el-form-item label="项目分类" prop="classification">
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.classification"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType == 10">
              <el-form-item label="项目类型" prop="projecttype">
                <el-select
                  v-if="CTform.bcz != null"
                  style="width: 100%"
                  v-model="CTform.bcz.projecttype"
                  disabled
                >
                  <el-option
                    v-for="item in Projecttype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType == 12">
              <el-form-item label="案件级别" >
                <el-select style="width: 100%" v-model="CTform.bcz.caselevel" placeholder="请选择" class="select" disabled>
                    <el-option v-for="item in Level" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item
                :label="chongCaseType == 10 ? '服务律师' : '代理律师'"
                prop="leadLawyer"
              >
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.leadLawyer"
                  class="select"
                  multiple
                  :multiple-limit="1"
                  @change="LeadLawyerChange(CTform.leadLawyer)"
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="代理律师" prop="coCounsel">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.coCounsel"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-if="
              (chongCaseType == 7 ||
                chongCaseType == 8 ||
                chongCaseType == 14 ||
                chongCaseType == 9) &&
              CTform.result == 1
            "
          >
            <el-col :span="14">
              <el-form-item label="风控委" prop="level">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.level"
                  class="select"
                  multiple
                  :multiple-limit="2"
                  disabled
                >
                  <el-option
                    v-for="item in FKW"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="CTform.result == 1">
            <el-form-item label="部门主管" prop="caseLeaderscase">
              <el-select
                filterable
                style="width: 100%"
                v-model="CTform.caseLeaderscase"
                placeholder="请选择"
                class="select"
                clearable
                @change="bmzgChange"
              >
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <!-- 与其他法律服务有关的招投标项目栏独有字段 -->
          <div v-if="chongCaseType == 10">
            <el-row>
              <el-col :span="14">
                <el-form-item label="开放时间" prop="opentime">
                  <el-date-picker
                    v-if="CTform.bcz != null"
                    style="width: 100%"
                    v-model="CTform.bcz.opentime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采购方式" prop="procuremethod">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.procuremethod"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item label="预算金额" prop="budgetmoney">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.budgetmoney"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采购编号" prop="procurecode">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.procurecode"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 专项服务合同独有字段 -->
          <div v-if="chongCaseType == 11">
            <el-row>
              <el-col :span="14">
                <el-form-item label="合同服务类型" prop="contracttype">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.contracttype"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="服务期限" prop="servicetime">
                  <el-date-picker
                    v-if="CTform.bcz != null"
                    style="width: 100%"
                    v-model="CTform.bcz.servicetime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-if="chongCaseType == 12">
            <el-row>
                <el-col :span="14">
                  <el-form-item label="项目负责人" >
                    <el-input v-model="CTform.bcz.porjectleader" placeholder="请输入" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="委托人摇号" >
                    <el-input v-model="CTform.bcz.lottery" placeholder="请输入" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="14">
                  <el-form-item label="管理人账号" >
                    <el-select style="width: 100%" v-model="CTform.bcz.administrator" placeholder="请选择"
                      class="select" disabled>
                      <el-option v-for="item in Administrator" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="!CTform.bcz.administrator">
                  <el-col :span="14">
                    <el-form-item label="开户账号" >
                      <el-input v-model="CTform.bcz.account" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="开户银行" >
                      <el-input v-model="CTform.bcz.bank" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
          </div>
          <div class="divider"></div>

          <el-row v-if="chongCaseType!=9">
            <el-col :span="14">
              <el-form-item v-if="chongCaseType!=12"
                :label="chongCaseType == 10 ? '采购单位' : '客户名称'"
                prop="bcz.procureunit"
              >
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.procureunit"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="债务人名称" prop="bcz.debtorName" v-if="chongCaseType==12">
                      <el-input
                        v-model="CTform.bcz.debtorName"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType != 10">
                    <el-form-item label="身份证号/社会信用代码/护照号" >
                      <el-input v-model="CTform.bcz.idnumber" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import {
  caseLawyerApi,
  bkInsert,
  caseInsertMenu,
  bkSelect,
  BKCaseConflict,
  ConflictMember,
  allCaseApi
} from '../../api/case'
import { GetDepartmentLeaders } from '../../api/bankrupt'
import { user } from '../../api/seal'
import { watch } from 'vue'
export default {
  name: 'case',
  // components:{
  //   Table
  // },
  data() {
    var ajstatusCheck = (rule, value, callback) => {
      if (value == null || value === undefined || value == '' || value == []) {
        callback(new Error('请输入或选择！'))
      }
      callback()
    }
    return {
      // isIndex: false,
      status: '',
      list: [],
      loading: false,
      statusOptions: [],
      enterForm: {},
      menu: true,

      form: {
        name: null,
        leadLawyer: null,
        coCounsel: null,
        soure: null,
        approvaldate: null,
        caseLeaders: null,
        level: null,
        sealtype: null,
        idnumber:null,
      },

      rules: {
        name: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        idnumber:[
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        leadLawyer: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        soure: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        approvaldate: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        caseLeaders: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        level: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        sealtype: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ]
      },

      SoureOptions: [
        { label: '投标', nikename: '投标' },
        { label: '指定', nikename: '指定' }
      ],
      // 代理律师
      Lawyer: [],
      // 部门审批人
      CaseLeaders: [],
      // 二次审批人
      Level: [],
      // 用章类型
      Seal: [
        { value: 'contract_seal', label: '合同章' },
        { value: 'corporate_seal', label: '法人章' },
        { value: 'official_seal', label: '公章' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' }
      ],
      detailsDialog: false,

      caseConflict: false,//案件冲突弹出框
      //二次利冲审批人
      conflictShow:false,//是否显示选择框，若无利冲或只有一个审批人的情况下不显示
      allConflictCount:0,//总冲突数量
      OptiomConflict:[],//所有二次利冲审批人
      formConflict:{
        conflictApproval:null,
      },
      rulesConflict:{
        conflictApproval: [{ required: true, message: '不能为空', trigger: 'blur' }],
      },
      conflictList: [],//冲突案件

      dialogshowAllCase:false,//是否显示全部冲突案件
      dialoghasMore:false,
      dialogallConflictCase:[],//所有的冲突案件
      dianji:false,
       isAdd:false,//确定提交
      isChong: false,//冲突案件预览弹出框
      chongCaseType: '',
       CTform: {
        casestatus: null,
        acceptcode: null, // 受理机构案号/受理案号
        id: null,
        assist: null, //法律援助(true是，false否）
        typeId: null, // 录入类型
        title: null, //案件名称
        code: null, //案件编号
        ajstatus: null, //案卷状态(节点名称)***
        approvaldate: null, //收案日期(委托时间)***
        source: null, // 项目概要/案件来源
        acceptUnit: null, //受理机构(受理单位)
        cause: null, //案由/项目来源
        leadLawyer: [], //代理律师(主办律师)***List
        remark: null, //委托事项
        level: [], //二次审批人/风控委
        coCounsel: [], //代理律师 List
        biddingSchemes: [], //合同上传 List
        chujuFiles: [], // 拟出具文件
        ordinaryFiles: [], //普通附件 List
        invoiceFile: [], //发票
        linkId: null, // 关联案件ID*** Guid
        status: null,
        caseLeaders: null, // 案件部门主管
        link: [],
        criminalrisk: null, //刑事风险控制人  Guid
        result: null,
        bs_Result: null,
        // 不复存在的
        bcz: {
          client: null, //委托人
          intervene: null, //介入阶段(0全程，1侦查阶段，2审查起诉阶段，3审判阶段）

          public_welfare: null, //是否是公益诉讼

          //------全都是<非诉案件>------
          partner: null, //项目合伙人
          draft: null, //底稿资料
          classification: null, //项目分类
          projecttype: null, //项目类型***  Guid
          opentime: null, //开放时间
          procuremethod: null, //采购方式
          budgetmoney: null, //预算金额
          procurecode: null, //采购编号
          contracttype: null, //合同服务类型
          servicetime: null, //服务期限
          procureunit: null, //采购单位/客户名称
          projecttype:null,
          idnumber:null,
        },
        // 案件当事人
        tableData: [
          {
            id: null,
            isUnit: null, //是否是个人***
            name: null, //姓名/单位名称***
            IsClient: false, //是否委托人***
            attribute: null, //当事人属性（原告被告等）***
            count: 1,
            idnumber:null,
          }
        ]
      },
      bianji: true,
      // 案卷状态
      Ajstatus: [
        { label: '一审', value: '一审' },
        { label: '二审', value: '二审' },
        { label: '再审', value: '再审' },
        { label: '破产申报', value: '破产申报' },
        { label: '破产申请', value: '破产申请' },
        { label: '再审听证', value: '再审听证' },
        { label: '强制清算', value: '强制清算' },
        { label: '行政复议', value: '行政复议' },
        { label: '首次执行', value: '首次执行' },
        { label: '恢复执行', value: '恢复执行' },
        { label: '执行异议', value: '执行异议' },
        { label: '仲裁阶段', value: '仲裁阶段' },
        { label: '侦查阶段', value: '侦查阶段' },
        { label: '审查起诉', value: '审查起诉' },
        { label: '受理', value: '受理' },
        { label: '未受理', value: '未受理' },
        { label: '无', value: '无' }
      ],
      // 底稿资料
      Draft: [
        { label: '已归档', value: true },
        { label: '未归档', value: false }
      ],
       ProjectType:[{label:"重整案件",value:"重整案件"},{label:"预重整",value:"预重整"},{label:"公益案件",value:"公益案件"}],  
        Administrator: [
        { value: false, label: '未开设' },
        { value: true, label: '已开设' }
      ], //管理人
      //是否代理
      isClient: [
        { value: true, label: '是' },
        { value: false, label: '否' }
      ],
      // 单位/个人
      typeOptions: [
        { value: true, label: '个人' },
        { value: false, label: '单位' }
      ], // 法律援助
      Flyz: [
        { label: '是', value: true },
        { label: '否', value: false }
      ],
      // 身份
      ArrtibuteOptions: [
        // { value: '原告', label: '原告' },
        // { value: '被告', label: '被告' },
        // { value: '第三人', label: '第三人' },
        // { value: '上诉人', label: '上诉人' },
        // { value: '被上诉人', label: '被上诉人' },
        // { value: '原审第三人', label: '原审第三人' },
        // { value: '原审原告', label: '原审原告' },
        // { value: '原审被告', label: '原审被告' },
        // { value: '申请人', label: '申请人' },
        // { value: '被申请人', label: '被申请人' },
        // { value: '债务人', label: '债务人' },
        // { value: '债权人', label: '债权人' },
        // { value: '公诉机关', label: '公诉机关' },
        // { value: '犯罪嫌疑人', label: '犯罪嫌疑人' },
        // { value: '自诉人', label: '自诉人' },
        // { value: '复议申请人', label: '复议申请人' },
        // { value: '复议被申请人', label: '复议被申请人' },
        // { value: '申请执行人', label: '申请执行人' },
        // { value: '被执行人', label: '被执行人' },
        // { value: '执行异议人', label: '执行异议人' }
      ],
isListPage: false  // 是否在列表页面
    }
  },
  async created() {
    await this.GetInsertMenu()
    await this.GetLawyer()
    this.LeadLawyerChange(this.form.leadLawyer)
  },
  methods: {
    // 查询
    bkCase() {
      bkSelect({
        name: null,
        leadLawyer: null,
        soure: null,
        starttime: null,
        endtime: null,
        status: null,
        page: this.currentPage,
        rows: this.pageSize
      })
        .then((res) => {
          if (res.data.status == 0) {
            this.total = parseInt(res.data.message)
            this.tableData = res.data.data
            // console.log('查询成功', res.data.data)
          }
        })
        .catch((err) => {
          console.log('查询失败', err)
        })
    },
    enter() {
      this.detailsDialog = true
    },
    async GetInsertMenu() {
      await caseInsertMenu({}).then((res) => {
        if (res.data.status == 'success') {
          this.statusOptions = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    SelectMenu(item) {
      this.$store.commit('setPage', 1)
      this.$router.push({
        query: {
          guid: this.$route.query.guid,
          status: this.$route.query.status,
          caseType: this.$route.query.caseType,
          mystatus: this.$route.query.mystatus,
          type: this.$route.query.type
        },
        path: item
      })
    },
    //提交案件
    inputCase(formref) {
      this.isAdd=true
      this.$refs[formref].validate((valid) => {
        if (valid) {
          //查询案件冲突
          this.GetCaseConflict()
        } else {
          this.isAdd=false
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          this.$message.error('请检查案件信息填写错误!')
        }
      })
    },
    
    // 代理律师/申请人/代理律师
    async GetLawyer() {
      await caseLawyerApi({}).then((res) => {
        if (res.data.status == 'success') {
          this.Lawyer = res.data.data.filter((item) => item.status == 0||item.status==6)
          // this.Lawyer = res.data.data
          this.form.leadLawyer = res.data.data[0].uid
          this.form.applicant = res.data.data[0].uid
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 获取案件审核部门主管
    GetDepartmentLeaders(lvshi) {
      if (lvshi == '' || lvshi == null) {
        return
      }

      GetDepartmentLeaders({
        Id: lvshi
      }).then((res) => {
        if (res.data.status == '0') {
          this.CaseLeaders = res.data.data
          var index = this.CaseLeaders.findIndex((item) => {
            return item.value == this.form.caseLeaders
          })
          // console.log("index:"+index)
          if (index == -1) {
            //不存在，清空
            this.form.caseLeaders = null
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 案件二次审批人/用章二次审批人
    GetLevel(lvshi) {
      if (lvshi == '' || lvshi == null) {
        return
      }
      user({
        Id: this.form.leadLawyer,
        apporver: 'case_00000000-0011-0011-0012-000000000000'
      }).then((res) => {
        if (res.data.status == 'success') {
          this.Level = res.data.data
          var index = this.Level.findIndex((item) => {
            return item.id == this.form.level
          })
          if (index == -1) {
            //不存在，清空二次审批人
            this.form.level = null
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 代理律师 改变
    LeadLawyerChange(lvshi) {
      this.GetDepartmentLeaders(lvshi)
      this.GetLevel(lvshi)
    },
    onMouseOver() {
      if (this.form.approvaldate != undefined && this.form != null) {
        this.$refs.iconDate.style.display = 'none'
      }
    },
    onMouseleave() {
      this.$refs.iconDate.style.display = 'block'
    },
      //关闭弹出框按钮
    handleClose() {
      this.detailsDialog = false;
      this.$refs["formref"].resetFields();
      this.form = {
         name: null,
        leadLawyer: null,
        coCounsel: null,
        soure: null,
        approvaldate: null,
        caseLeaders: null,
        level: null,
        sealtype: null,
        idnumber:null,
      };
      this.conflictList=[]
    },

    //获取案件冲突
   async GetCaseConflict(){
      // debugger
      await BKCaseConflict({
        name: this.form.name,
        idnumber:this.form.idnumber
      }).then((res) => {
        // debugger
        if (res.data.status == 'success') {
          this.dialoghasMore=false
          this.dialogshowAllCase=false
          this.allConflictCount=0
          if (res.data.data.length > 0) {
            this.dialogallConflictCase = res.data.data
            
              this.conflictList = this.dialogallConflictCase.filter(item => item.isClient == 1)//所有有冲突的案件
              this.allConflictCount  = this.allConflictCount +this.conflictList.length
              if(this.conflictList.length==0){//没有冲突案件
                this.conflictList.push(this.dialogallConflictCase[0])
              } 
              if(this.dialogallConflictCase.length>this.conflictList.length&&this.dialogallConflictCase.length>1){
                this.dialoghasMore=true
              }
               if(this.allConflictCount>0){//有冲突的数量大于0
                  this.GetConflictMember()//获取所有二次利冲审批人
                }else{
                  this.caseConflict = true//打开冲突弹出框
                }
          }else{//完全没有冲突
            this.addEnter()
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.isAdd=false
          this.$message.error(res.data.message)
        }
      })
    },

     // 取消录入
    CancelEntry() {
      this.conflictList = []
      this.caseConflict = false // 冲 突
      this.dialogshowAllCase=false
      this.dialoghasMore=false
      this.isAdd=false
      this.formConflict.conflictApproval=null
    },
     tableRowClass({ row, rowIndex }){
      // console.log("isoth",row.isOther)
      if (row.isOther) {
        return 'beig-row';
      }else{
        return '';
      }
      
    },
      //获取二次利冲审批人
   async GetConflictMember(){
      ConflictMember().then((res) => {
        if(res.data.status=="success"){
          this.OptiomConflict=res.data.data
          this.caseConflict = true
                 
          if(this.OptiomConflict.length>1){
            this.conflictShow=true
          }else if(this.OptiomConflict.length==1){
             this.conflictShow=false
             this.formConflict.conflictApproval=this.OptiomConflict[0].value
          }
        }else{
          this.$message.error(res.data.message)
        }
      })
    },
     // 继续录入
    conflict(formref) {
      this.loading = true
      this.dianji = true
      this.$refs[formref].validate((valid) => {
        if (valid) {
          this.caseConflict = false // 冲突
          this.addEnter()
        }else{
          this.dianji = false
          this.loading=false
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
        }
      }
      )
      
    },
    //录入数据
    addEnter(){
      this.loading = true
      this.dianji = true
      this.isAdd=true
      bkInsert({
            name: this.form.name,
            leadLawyer: this.form.leadLawyer,
            coCounsel: this.form.coCounsel,
            soure: this.form.soure,
            approvaldate: this.form.approvaldate,
            caseLeaders: this.form.caseLeaders,
            level: this.form.level,
            sealtype: this.form.sealtype,
            idnumber:this.form.idnumber,
            conflictApproval:this.formConflict.conflictApproval==''?null:this.formConflict.conflictApproval,
          })
            .then((res) => {
              if (res.data.status == 0) {
                 
                this.$message.success(res.data.message)
                if(this.isListPage ){
                  this.$refs.childView.inputCase()
                }
                // this.bkCase()
              } else {
                this.$message.error(res.data.message)
              }
              // this.$refs[formref].resetFields()
              this.loading = false
              this.dianji = false
              this.isAdd=false
            })
            .catch((error) => {
              console.log(error)
               this.loading = false
              this.dianji = false
              this.isAdd=false
              this.$message.error('前台错误！')
            })
            
          this.detailsDialog = false
    },
     dialogshowAllCaseClick(){
      if(this.dialogshowAllCase){
        this.dialogshowAllCase=false
        this.conflictList = this.dialogallConflictCase.filter(item => item.isClient == 1)//所有有冲突的案件
        if(this.conflictList.length==0){//没有冲突案件
          this.conflictList.push(this.dialogallConflictCase[0])
        } 
       
      }else{
        this.conflictList=this.dialogallConflictCase
        this.dialogshowAllCase=true
      }
    },
     getRandomColor(item, show) {
      if (show) return '#e86e30'
      else if (item) return 'blue'
    },
    addRedStar(h, { column }) {
      // 给表头加必选标识
      return [
        h('span', { style: 'color: red' }, '*'),
        h('span', ' ' + column.label)
      ]
    },
     // 案件当事人背景颜色
    tableRowClassName({ row, rowIndex }) {
      console.log()
      if (row.isClient||row.IsClient) {
        return 'isclient-row'
      } else {
        return ''
      }
    },
     GetNameIdnumber(data){
      const filtered = data.flatMap(item => 
        item.all
          .filter(person => person.isshow)
          .map(person => ({ 
            name: person.name, 
            idnumber: person.idnumber 
          }))
      );

      // 步骤2：格式化为"姓名(身份证号)"格式，多个用逗号隔开
      const resultStr = filtered.map(item => {
        // 处理身份证号为空或不存在的情况，显示"无"
        const idStr = item.idnumber || "无";
        return `${item.name}(${idStr})`;
      }).join(',');
      return resultStr
    },
    // 案件冲突查看
    conflictClick(row) {
      
      this.chongCaseType = row.typeId.substring(21, 23)
      allCaseApi({
        Id: row.id,
        SelectType: 1 //（0：案件管理，1：案件明细）
      }).then((res) => {
        if (res.data.status == '0') {
          // console.log('res.data.data[0]', res.data.data[0])
          // 案件信息
          this.CTform = res.data.data[0];
          this.CTform.tableData = res.data.data[0].tableData
          //其他东西
          this.CTform.bcz = Object.assign({}, this.CTform.bcz, JSON.parse(res.data.data[0].bcz));
          // this.CTform = res.data.data[0]
          // this.CTform.tableData = res.data.data[0].tableData
          // //其他东西
          // this.CTform.bcz = JSON.parse(res.data.data[0].bcz)
          for (var i = 0; i < this.CTform.biddingSchemes.length; i++) {
            var name = this.CTform.biddingSchemes[i].name.split('.')[0]
            var type = this.CTform.biddingSchemes[i].name.substring(
              this.CTform.biddingSchemes[i].name.lastIndexOf('.') + 1
            )
          }
          this.isChong = true
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
     closChong() {
      this.isChong = false
    },
  },
  filters: {
    getRouterActive(path) {
      let str = path.split('/')
      return str[3]
    }
  },
  computed: {
    targetRoutes() {
      let target = this.$store.state.permission.addRoutes.filter(
        (el) => el.path == '/home/bankruptcy' //遍历每一个数组，过滤出返回值委true的值
      )
      var tar = target[0].children.filter((el) => el.hidden != true)
      // console.log('tar', tar)
      return tar
    },
    key() {
      return this.$route.name
    }
  },
  watch:{
   '$route.name': {
      handler(newName) {
        console.log(newName)
        // 把 'CaseList' 换成你实际的列表页路由名称
        this.isListPage = newName === 'bankruptcyManagerInfo'
      },
      immediate: true
    }
}
}

</script>
<style lang="less" scoped>
#seal .index {
  width: 100%;
  margin: auto;
  border-radius: 16px;
  position: relative;
 
}

#seal .el-menu {
  display: flex;
  text-align: center;
  border-right: 0px;
  // margin-bottom: 5vh;
  // .el-menu-item{
  //   width:20vh;
  // }

  .el-menu-item {
    font-size: 16px;
    height: 55px;

    &:hover {
      background-color: #fff;
      color: #409eff !important;
      border-bottom: 1px solid #409eff;
    }
  }

  .el-menu-item.is-active {
    background-color: #fff !important;
    border-bottom: 1px solid #409eff;
    color: #409eff !important;
  }
}

#seal .el-menu.el-menu--horizontal {
  border-bottom: none;
}

#seal .menu {
  width: 96%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#seal /deep/.el-card__body,
#seal .el-main {
  padding: 0px;
  padding-bottom: 20px;

}

#seal .xian {
  width: 100%;
  border-bottom: 1px solid rgba(238, 239, 242, 1);
  margin-bottom: 24px;

}

#seal .btn {
  position: absolute;
  top: 8px;
  right: 2%;
  z-index: 2;
  // position:absolute;
  // top:130px;
  // right: 2%;
}

#seal .kb {
  width: 98px;
  height: 48px;
  position: absolute;
  top: 8px;
  right: 2%;
  background: #fff;
  z-index: 1;
}
  //主体
.text {
  width: 100%;
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 1.1875rem;
  font-weight: 400;
  padding-left: 3.625rem;
  margin-bottom: 2rem;
}
::v-deep .el-input.is-disabled .el-input__inner {
  color: #606266 !important;
}

::v-deep .el-tag.el-tag--info {
  color: #606266 !important;
}



  .icon {
  width: 4px;
  height: 18px;
  background: #3077e6;
  border-radius: 9px;
  margin-right: 5px;
}

  .top {
  width: 100%;
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 19px;
  font-weight: 400;
  padding-left: 58px;
  margin-bottom: 32px;
}
.select {
  width: 100%;
}

.divider {
  width: calc(100% - 50px);
  float: right;
  border-top: 1px solid rgba(238, 239, 242, 1);
  margin-bottom: 32px;
  margin-top: 10px;
}

// 日历
::v-deep .el-input__prefix {
  display: none;
}

.date_box {
  .el-icon-date {
    position: absolute;
    top: 50%;
    right: 10px;
    z-index: 9;
    color: #c0c4cc;
    font-size: 14px;
    transform: translateY(-50%);
  }

  /deep/ .el-range__close-icon {
    position: absolute;
    right: 34px;
    top: 54%;
    transform: translateY(-50%);
  }

}
//表格
.detail::v-deep .el-table th.el-table__cell {
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: #fafafa;
}

.party {
  margin-bottom: 55px;
  margin-left: 5%;
  ::v-deep .isclient-row {
    background: #fff1dc;
  }

  ::v-deep .el-table__body tr:hover > td {
    background-color: transparent !important;
  }
  ::v-deep .el-input__inner {
    border: none;
    height: 24px;
    line-height: 24px;
    text-align: center;
  }
}

// ::v-deep tbody tr:hover > td {
//   background-color: transparent !important;
// }
/deep/ .el-table th {
  //标题背景色
  background-color: #fafafa;
}

.copy {
  color: #3077e6;
  cursor: pointer;
}

.bgdel {
  color: #fe964a;
  margin-left: 8px;
  cursor: pointer;
}

.party /deep/.el-input__icon {
  height: 100%;
  width: 25px;
  text-align: center;
  transition: all 0.3s;
  line-height: 24px;
}
#seal ::v-deep .el-input--prefix .el-input__inner {
  padding-left: 15px;
}

  </style>